import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class GridBuilderService {

  private readonly ACTION_ID = 89;
  private readonly GRID_ID = 36;
  private readonly adminApiUrl = environment.admin_api_url;
  private readonly baseUrl = environment.base_url;

  constructor(private http: HttpClient) {}

  loadGridData(
    baseUrl: string,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/loadGridJson?action_id=${this.ACTION_ID}&grid_id=${this.GRID_ID}`;
    const globalParams = globalService?.globalParams ?? globalService ?? {};
    const params = { ...globalParams, ...filterParams };

    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post<any>(url, params, { headers, withCredentials: true });
  }

  saveGrid(data: any): Observable<any> {
    return this.http.post<any>(`${this.adminApiUrl}/saveGrid`, data, { withCredentials: true });
  }

  genGridHeader(data: { action_id: number | string }): Observable<any> {
    return this.http.post<any>(`${this.adminApiUrl}/generateGridHeader`, data, { withCredentials: true });
  }

  getGridHeaderByKey(data: { grid_key: number | string }): Observable<any> {
    return this.http.post<any>(`${this.adminApiUrl}/gridHeaderByKey`, data, { withCredentials: true });
  }

  saveGridAction(data: any): Observable<any> {
    return this.http.post<any>(`${this.adminApiUrl}/saveGridAction`, data, { withCredentials: true });
  }

  saveScreenModal(data: any): Observable<any> {
    return this.http.post<any>(`${this.adminApiUrl}/saveScreenModal`, data, { withCredentials: true });
  }

  getScreenModalName(data: { client_key: string | number }): Observable<any> {
    return this.http.post<any>(`${this.adminApiUrl}/getScreenModalNme`, data, { withCredentials: true });
  }

  getActionsByGrid(data: { client_key: string | number; grid_key: string | number }): Observable<any> {
    return this.http.post<any>(`${this.adminApiUrl}/getActionsByGrid`, data, { withCredentials: true });
  }

  removeGridAction(data: { client_key: string | number; grid_action_key: string | number }): Observable<any> {
    return this.http.post<any>(`${this.adminApiUrl}/removeGridActionName`, data, { withCredentials: true });
  }
}
